import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { EquipmentSection } from './Equipment';
import { LocationAndPremises } from './LocationAndPremises';
import { OtherAssets } from './OtherAssets';
import { PartnersSection } from './PartnersSection';
import { ProductionSection } from './ProductionSection';
import { QualityControl } from './QualityControl';
import { TechnologicalProcess } from './TechnologicalProcess';
import { WorkingResources } from './WorkingResources';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.LOCATION_AND_PREMISES]: LocationAndPremises,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.EQUIPMENT]: EquipmentSection,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.ASSETS]: OtherAssets,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.TECHNOLOGICAL_PROCESS]: TechnologicalProcess,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.WORKING_RESOURCES]: WorkingResources,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.PARTNERS]: PartnersSection,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.PRODUCTION]: ProductionSection,
  [BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.QUALITY]: QualityControl,
};

export const BusinessOperations: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
